var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranchAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9498 1.8V46.2C40.9498 47.196 40.1458 48 39.1498 48H8.8498C7.8538 48 7.0498 47.196 7.0498 46.2V1.8C7.0498 0.804 7.8538 0 8.8498 0H39.1498C40.1458 0 40.9498 0.804 40.9498 1.8Z",
    fill: "#ECF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9498 6.918V1.8C40.9498 0.804 40.1458 0 39.1498 0H8.8498C7.8538 0 7.0498 0.804 7.0498 1.8V6.918H40.9498Z",
    fill: "#626C78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0498 41.082V46.2C7.0498 47.196 7.8538 48 8.8498 48H39.1498C40.1458 48 40.9498 47.196 40.9498 46.2V41.082H7.0498Z",
    fill: "#626C78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1086 3.45545C30.1086 3.73745 29.8806 3.97145 29.5926 3.97145H18.4086C18.1266 3.97145 17.8926 3.73745 17.8926 3.45545C17.8926 3.16745 18.1266 2.93945 18.4086 2.93945H29.5866C29.8806 2.93945 30.1086 3.16745 30.1086 3.45545V3.45545Z",
    fill: "#3C4B59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0007 46.1997C24.9153 46.1997 25.6567 45.4583 25.6567 44.5437C25.6567 43.6291 24.9153 42.8877 24.0007 42.8877C23.0861 42.8877 22.3447 43.6291 22.3447 44.5437C22.3447 45.4583 23.0861 46.1997 24.0007 46.1997Z",
    fill: "#3C4B59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6768 37.7716H14.9897C14.6211 37.7716 14.3223 37.4728 14.3223 37.1042V10.8969H33.6768V37.7716Z",
    fill: "#F9F9F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2533 15.3558H18.2609C17.6935 15.3558 17.2334 14.8957 17.2334 14.3283C17.2334 13.7609 17.6935 13.3008 18.2609 13.3008H20.2533C20.8207 13.3008 21.2808 13.7609 21.2808 14.3283C21.2808 14.8957 20.8207 15.3558 20.2533 15.3558Z",
    fill: "#D3D3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7037 19.6722H18.2609C17.6935 19.6722 17.2334 19.2121 17.2334 18.6447C17.2334 18.0773 17.6935 17.6172 18.2609 17.6172H29.7037C30.2712 17.6172 30.7312 18.0773 30.7312 18.6447C30.7312 19.2121 30.2712 19.6722 29.7037 19.6722Z",
    fill: "#D3D3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7853 23.9691H18.2609C17.6935 23.9691 17.2334 23.509 17.2334 22.9416C17.2334 22.3742 17.6935 21.9141 18.2609 21.9141H25.7853C26.3528 21.9141 26.8128 22.3742 26.8128 22.9416C26.8128 23.5091 26.3528 23.9691 25.7853 23.9691Z",
    fill: "#D3D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7056 28.2679H18.2629C17.6954 28.2679 17.2354 27.8078 17.2354 27.2404C17.2354 26.673 17.6954 26.2129 18.2629 26.2129H29.7056C30.2732 26.2129 30.7331 26.673 30.7331 27.2404C30.7331 27.8078 30.2732 28.2679 29.7056 28.2679Z",
    fill: "#D3D3D3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 30,
    height: 30,
    rx: 14,
    fill: "#D8E2E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9565_257614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9023 45.2258C23.9023 45.0601 24.0367 44.9258 24.2023 44.9258H41.6861C41.8518 44.9258 41.9861 45.0601 41.9861 45.2258V46.3977C41.9861 46.5633 41.8517 46.6977 41.6861 46.6977H24.2023C24.0367 46.6977 23.9023 46.5633 23.9023 46.3977V45.2258Z",
    fill: "#1E3D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1657 44.926H25.7227V26.2176C25.7227 26.0144 25.8034 25.8194 25.9471 25.6757C26.0909 25.5319 26.2858 25.4512 26.4891 25.4512H39.3992C39.6025 25.4512 39.7974 25.5319 39.9412 25.6757C40.0849 25.8194 40.1657 26.0144 40.1657 26.2176V44.926Z",
    fill: "#2B3A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7881 40.6133H35.1004V44.9256H30.7881V40.6133Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6387 27.8672C27.6387 27.591 27.8625 27.3672 28.1387 27.3672H31.031C31.3071 27.3672 31.531 27.591 31.531 27.8672V28.7144C31.531 28.9905 31.3071 29.2144 31.031 29.2144H28.1387C27.8625 29.2144 27.6387 28.9905 27.6387 28.7144V27.8672Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6387 31.8535C27.6387 31.5774 27.8625 31.3535 28.1387 31.3535H31.031C31.3071 31.3535 31.531 31.5774 31.531 31.8535V32.7007C31.531 32.9768 31.3071 33.2007 31.031 33.2007H28.1387C27.8625 33.2007 27.6387 32.9768 27.6387 32.7007V31.8535Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6387 35.8408C27.6387 35.5647 27.8625 35.3408 28.1387 35.3408H31.031C31.3071 35.3408 31.531 35.5647 31.531 35.8408V36.688C31.531 36.9641 31.3071 37.188 31.031 37.188H28.1387C27.8625 37.188 27.6387 36.9641 27.6387 36.688V35.8408Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3574 27.8672C34.3574 27.591 34.5813 27.3672 34.8574 27.3672H37.7495C38.0257 27.3672 38.2495 27.591 38.2495 27.8672V28.7144C38.2495 28.9905 38.0257 29.2144 37.7495 29.2144H34.8574C34.5813 29.2144 34.3574 28.9905 34.3574 28.7144V27.8672Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3574 31.8535C34.3574 31.5774 34.5813 31.3535 34.8574 31.3535H37.7495C38.0257 31.3535 38.2495 31.5774 38.2495 31.8535V32.7007C38.2495 32.9768 38.0257 33.2007 37.7495 33.2007H34.8574C34.5813 33.2007 34.3574 32.9768 34.3574 32.7007V31.8535Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3574 35.8408C34.3574 35.5647 34.5813 35.3408 34.8574 35.3408H37.7495C38.0257 35.3408 38.2495 35.5647 38.2495 35.8408V36.688C38.2495 36.9641 38.0257 37.188 37.7495 37.188H34.8574C34.5813 37.188 34.3574 36.9641 34.3574 36.688V35.8408Z",
    fill: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 32C36.9787 32 34.9297 34.049 34.9297 36.5703C34.9297 37.4234 35.1659 38.2537 35.6153 38.9698L39.1902 44.8201C39.2512 44.9191 39.3426 44.9801 39.4492 44.9953C39.5939 45.0182 39.754 44.9572 39.8377 44.8125L43.4229 38.9088C43.8494 38.208 44.0703 37.393 44.0703 36.5703C44.0703 34.049 42.0213 32 39.5 32ZM39.5 38.8555C38.2204 38.8555 37.2148 37.8195 37.2148 36.5703C37.2148 35.3135 38.2431 34.2852 39.5 34.2852C40.7569 34.2852 41.7852 35.3135 41.7852 36.5703C41.7852 37.8119 40.7949 38.8555 39.5 38.8555Z",
    fill: "#FF981B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 32V34.2852C40.7569 34.2852 41.7852 35.3135 41.7852 36.5703C41.7852 37.8119 40.7949 38.8555 39.5 38.8555V44.9998C39.63 45.0028 39.7636 44.9405 39.8377 44.8125L43.4229 38.9088C43.8494 38.208 44.0703 37.393 44.0703 36.5703C44.0703 34.049 42.0213 32 39.5 32Z",
    fill: "#FFB331"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9565_257614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchAccounting);
export default __webpack_public_path__ + "static/media/branchAccounting.fa314b5aa9f3989ea1486ca5b894e0cf.svg";
export { ForwardRef as ReactComponent };